package io.horion.cv.models

import io.horion.cv.api.datasource.cv.Model

object CvData {
    val cvList = mapOf(
        Model.SIMPLE.name to "cv_simple.webp",
        Model.CV2.name to "cv2.webp",
        Model.CV3.name to "cv3.webp",
        Model.CV5.name to "cv5.webp",
        Model.CV6.name to "cv6.webp",
        Model.CV7.name to "cv7.webp",
        Model.CANADA.name to "cv_canada.webp",
    )
}